export default "/images/vendor/flag-icon-css/flags/1x1/bo.svg?ee5938f07b3324e9af6d22cc2b9dc1ac";